import './SelectedSerialTickets.scss'

import { ButtonEmpty } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import { getSelectedSerialTicketsGroupedByRoute } from '../../../selectors/selectors'
import { RouteForSummary } from '../../common/Route'

export default function SelectedSerialTickets() {
  const selectedSerialTickets = useSelector(getSelectedSerialTicketsGroupedByRoute)

  return (
    <div className="selected-serial-tickets">
      {selectedSerialTickets.map(({ tickets, from, to }) => (
        <div className="direction-group" key={from}>
          <RouteForSummary from={from} to={to} />
          {tickets.map(ticket => (
            <SelectedSerialTicket key={ticket.code} {...ticket} />
          ))}
        </div>
      ))}
    </div>
  )
}

function SelectedSerialTicket({ count, code, nameNarrow }) {
  const handleClick = () => {
    const el = document.getElementById(code)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <ButtonEmpty className="selected-serial-ticket" onClick={handleClick}>
      <div className="count">{`${count} × `}</div>
      <div className="name" dangerouslySetInnerHTML={{ __html: `${nameNarrow} →` }} />
    </ButtonEmpty>
  )
}

SelectedSerialTicket.propTypes = {
  code: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  nameNarrow: PropTypes.string.isRequired
}
